import ajax from 'Site/js/util/ajax.fetch';
import dropdownDirective from 'Site/directive/dropdown';
import store from 'Site/js/store';

export default {
    directives: {
        dropdown: dropdownDirective
    },
    methods: {
        deleteStory(id, confirmationMessage) {
            store.dispatch('showConfirm', {
                text: confirmationMessage,
                callback() {
                    ajax.delete('stories', { id }).then((response) => {
                        store.dispatch('notify', { msg: response.message });
                        window.location.reload();
                    });
                }
            });
        },
        hideOnProfile(id, hiddenAuthor) {
            hiddenAuthor = hiddenAuthor ? 0 : 1;
            ajax.update('stories', { id, hiddenAuthor }).then((response) => {
                store.dispatch('notify', { msg: response.message });
            });
        }
    }
};
